import * as ActionTypes from 'state/types'

export const activityReceived = (activity) => ({
  type: ActionTypes.RECEIVE_ACTIVITY,
  activity
})
export const updateActivity = (payload) => ({
  type: ActionTypes.UPDATE_ACTIVITY,
  payload
})
export const sendMessage = (speech) => ({
  type: ActionTypes.SEND_ACTIVITY,
  speech
})
export const resendMessage = (payload) => ({
  type: ActionTypes.RESEND_ACTIVITY,
  payload
})
export const addMessage = (payload) => ({
  type: ActionTypes.ADD_MESSAGE,
  payload
})
export const socketReconnectionError = () => ({
  type: ActionTypes.SOCKET_RECONNECTION_ERROR
})

export const activityStartReceived = (payload) => ({
  type: ActionTypes.RECEIVE_ACTIVITY_START,
  payload
})
export const removeBusyTyping = (payload) => ({
  type: ActionTypes.REMOVE_BUSY_TYPING,
  payload
})

export const sendActivityStart = (payload) => ({
  type: ActionTypes.SEND_ACTIVITY_START,
  payload
})
